module.exports = __webpack_public_path__ + "img/logo_comum_azul.35b86781.svg";